import * as config from './../config/config'
import api from './interceptor'


export async function createProvision(currentProvision){
  try {
    currentProvision['user_id'] = localStorage.getItem('user_id')
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_PROVISION, currentProvision);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function getProvisions(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_PROVISION);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function getMMarchandises(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LISTE_MARCHANDISE);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function downloadProvision(record){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_DOWNLOAD_PROVISION + record.id, 
      {responseType: "blob"}
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `provision_export.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function createDossier(dossier){
  try {
    dossier['user_id'] = localStorage.getItem('user_id')
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_PROVISION_DOSSIER, dossier);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function updateDossier(dossier){
  try {
    dossier['user_id'] = localStorage.getItem('user_id')
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_PROVISION_DOSSIER + dossier['id'], dossier);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function updateDossierStatus(dossier_id, status){
  try {
    const payload = {
      'statut': status,
      'user_id': localStorage.getItem('user_id')
    }
    const response = await api.put(config.REACT_APP_ENDPOINT_TOGGLE_PROVISION_DOSSIER + dossier_id, 
     payload
    );
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function getAllDossier(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_GET_PROVISION_DOSSIER);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function getAllTransitDocument(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function attachTransitDocument(fd){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT_ATTACH, fd);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function downloadTransitDocument(dossier_id){
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_GET_PROVISION_DOCUMENT_DOWNLOAD + dossier_id,
      {
        responseType: "blob", // 🔥 IMPORTANT
      }
    );

    return response;

  } catch (error) {
    throw error;
  }
}

export async function getAllCategoriesTransit(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_GET_PROVISION_CATEGORIES);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export async function createDevisTransit(payload){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_DEVIS_TRANSIT, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function updateDevisTransit(payload){
  const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_DEVIS_TRANSIT, payload);
    return response.data;
}

export async function toggleDevisTransit(payload){
  const response = await api.post(config.REACT_APP_ENDPOINT_UPDATE_STATUT_DEVIS_TRANSIT, payload);
    return response.data;
}


export async function getDevisTransit({ devis_id, dossier_id } = {}){
  try {
    const response = await api.get(
      config.REACT_APP_ENDPOINT_GET_DEVIS_TRANSIT,
      {
        params: {
          ...(devis_id && { devis_id }),
          ...(dossier_id && { dossier_id }),
        }
      }
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function downloadDevisTransit(payload) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_DOWNLOAD_DEVIS_TRANSIT,
      payload,
      {
        responseType: "blob" // 🔥 IMPORTANT
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data], {
      type: "application/pdf"
    }));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "devis_export.pdf");

    document.body.appendChild(link);
    link.click();
    link.remove();

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getTransitFacture(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_FACTURE_TRANSIT);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function updateStatutFacture(payload){
  try {
    const response = await api.post(config.REACT_APP_ENDPOINT_TOGGLE_FACTURE_TRANSIT, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function downloadFactureTransit(payload) {
  try {
    const response = await api.post(
      config.REACT_APP_ENDPOINT_DOWNLOAD_FACTURE_TRANSIT,
      payload,
      {
        responseType: "blob" // 🔥 IMPORTANT
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data], {
      type: "application/pdf"
    }));

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "facture_export.pdf");

    document.body.appendChild(link);
    link.click();
    link.remove();

    return response.data;
  } catch (error) {
    throw error;
  }
}